import styled from "styled-components";
import { colors, font, radius } from "../../styles/theme/tokens";

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-family: ${font.text};
  font-size: 14px;
  color: ${colors.muted};
`;

export const Segmented = styled.div`
  display: inline-flex;
  padding: 3px;
  border-radius: ${radius.sm};
  background: ${colors.brandSoft};
`;

export const Segment = styled.button`
  font-family: ${font.text};
  font-size: 13px;
  font-weight: 700;
  padding: 6px 12px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: ${({ $active }) => ($active ? "#FFFFFF" : colors.brandDeep)};
  background: ${({ $active }) => ($active ? colors.brand : "transparent")};
  transition: background 0.2s;

  &:disabled {
    cursor: default;
    opacity: ${({ $active }) => ($active ? 1 : 0.4)};
  }
`;

export const Hint = styled.small`
  font-size: 12px;
  color: ${colors.muted};
`;
